import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=6db78b32&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=ts"
export * from "./Mobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db78b32",
  null
  
)

export default component.exports